module.exports = __webpack_public_path__ + "img/Karriere_Smartphone.fed4c82d.jpg";